import { gql } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { Timestamp } from 'src/lib/graphqlTypes/customScalarTypes';

export const deleteGraphMutation = gql`
  mutation Graph__DeleteGraphMutation($serviceId: ID!) {
    service(id: $serviceId) {
      service {
        id
        account {
          id
        }
      }
      delete
    }
  }
`;

export const getRecentlyUpdatedVariants = (
  service: GraphQLTypes.DeleteGraphCardServiceFragment,
) => {
  const fromLast30Days = (reportedTime: Timestamp['output']) => {
    const currentDate = new Date();
    const priorDate = new Date(reportedTime);
    const msBetweenDates = Math.abs(
      priorDate.getTime() - currentDate.getTime(),
    );
    //     convert ms to days                 hour   min  sec   ms
    const daysBetweenDates = msBetweenDates / (24 * 60 * 60 * 1000);
    return daysBetweenDates <= 30;
  };

  const recentlyUpdatedVariants = service.variants
    .filter((variant) => {
      const variantChecks = variant?.usageLastReportedAt;
      const variantSchemaUpdates = variant?.activeSchemaPublish?.publishedAt;
      if (variantChecks || variantSchemaUpdates) {
        if (variantSchemaUpdates) {
          return fromLast30Days(variantSchemaUpdates);
        } else if (variantChecks) {
          return fromLast30Days(variantChecks);
        }
      }
      return null;
    })
    .filter((element) => element !== null);

  return recentlyUpdatedVariants;
};
